import React from "react";
import "./Shimmer.scss";

export const Shimmer: React.FC = ({ children }) => (
  <div className="c-shimmer">{children}</div>
);
